import _ from "lodash";
import ActionTypeCliente from "../ActionTypeCliente";
import Contacto from "../../Contacto";
import GeneradorDeSecuencia from "../../GeneradorDeSecuencia";
// import { v4 } from "uuid";

export default class SalirDeNombreDeContacto extends ActionTypeCliente {
    ejecutar(estado, nuevoEstado) {
        const atributosActuales = estado.domain.screen.contactos.atributos;
        // const nuevosAtributos = nuevoEstado.domain.screen.contactos.atributos;
        /* if(estado.domain.screen.contactos.data.find((contacto) => contacto.nombre===atributos.nombre)){
            return nuevoEstado;
        }
 */
        const indexSeleccionado = estado.domain.screen.contactos.indexSeleccionado;
        /*if(estado.domain.screen.contactos.listaNombres.find((nombreDeLista) => atributosActuales.nombre===nombreDeLista.nombre)){
            
            if(estado.domain.screen.contactos.valorListaNombres.nombre ===
                Contacto.labelDefinirNuevoContacto){
                nuevosAtributos.nombre = estado.domain.screen.contactos.data[indexSeleccionado].nombre;
            }else{
                nuevosAtributos.nombre = estado.domain.screen.contactos.data[indexSeleccionado].nombre;
            }
            return nuevoEstado;
        } */
        const ultimoIndice = estado.domain.screen.contactos.listaNombres.length-1;


        if (
            indexSeleccionado === ultimoIndice &&
            atributosActuales.nombre !== Contacto.labelDefinirNuevoContacto

        ) {
            // let contactoDefinirNuevo = estado.domain.screen.contactos.valorListaNombres;
            // let contactoDefinirNuevo = estado.domain.screen.contactos.data[estado.domain.screen.contactos.indexSeleccionado];
            
            let nuevoContacto = new Contacto(
                atributosActuales.nombre,
                atributosActuales.rol,
                atributosActuales.telcel1,
                atributosActuales.telcel2,
                atributosActuales.telfijo,
                atributosActuales.email,
                /* contactoDefinirNuevo.nombre,
                contactoDefinirNuevo.rol,
                contactoDefinirNuevo.telcel1,
                contactoDefinirNuevo.telcel2,
                contactoDefinirNuevo.telfijo,
                contactoDefinirNuevo.email, */
            );
            nuevoEstado.domain.screen.contactos.data.push(nuevoContacto);
            // Contacto.iniciarlizarContactoDefinirNuevo(nuevoEstado.domain.screen.contactos.valorListaNombres);
            const nuevoValorListaNombres = { sec: GeneradorDeSecuencia.siguienteNroSecuencial(), nombre: atributosActuales.nombre };
            nuevoEstado.domain.screen.contactos.valorListaNombres = nuevoValorListaNombres;
            
            // const listaNombres = estado.domain.screen.contactos.listaNombres;
            nuevoEstado.domain.screen.contactos.listaNombres.splice(
                // listaNombres.length - 1,
                ultimoIndice,
                0,
                // {nombre: screenAtributos.nombre}
                {
                    sec: nuevoValorListaNombres.sec,
                    nombre: nuevoValorListaNombres.nombre
                },
            );
            // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre: screenAtributos.nombre};

            nuevoEstado.domain.screen.contactos.contactoPorDefinir = Contacto.crearContactoDefinirNuevo();
            // _.set(nuevoEstado.domain.screen.contactos.atributos, this.pathAtributo, this.payload);
            return nuevoEstado;
            // _.set(nuevoContacto, this.pathAtributo, this.payload);
            // nuevoEstado.domain.screen.contactos.indexData=0;
            // let atributo = _.words(this.pathAtributo,/[^\\.]+/g).pop();
            // _.set(nuevoEstado.domain.screen.personasContacto.atributos, this.pathAtributo, this.payload);
        }

        if (
            indexSeleccionado === ultimoIndice &&
            atributosActuales.nombre === Contacto.labelDefinirNuevoContacto
        ){
            return nuevoEstado;
        }

        // let atributos = estado.domain.screen.contactos.atributos;
        // nuevoEstado.domain.screen.contactos.data[indexSeleccionado] = atributos;
        
        
        /* if(estado.domain.screen.contactos.listaNombres.find((valorListaNombres) => valorListaNombres.nombre===atributos.nombre)){
            return nuevoEstado;
        } */
        
        // let indexSeleccionado = estado.domain.screen.contactos.indexSeleccionado;
        // const valorListaNombresActual =estado.domain.screen.contactos.valorListaNombre;


        //indexSeleccionado < ultimoIndice
        const nuevoValorListaNombres  =nuevoEstado.domain.screen.contactos.valorListaNombres;
        // nuevoValorListaNombres.sec    =valorListaNombresActual.sec;
        nuevoValorListaNombres.nombre =atributosActuales.nombre;
        
        nuevoEstado.domain.screen.contactos.listaNombres.splice(
            indexSeleccionado,
            1,
                // {nombre: screenAtributos.nombre}
            {
                sec: nuevoValorListaNombres.sec,
                nombre: nuevoValorListaNombres.nombre
            },
        );
            // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre: screenAtributos.nombre};
        // nuevoEstado.domain.screen.contactos.valorListaNombres = nuevoValorListaNombres;

        // nuevoEstado.domain.screen.contactos.listaNombres[indexSeleccionado].nombre = atributos.nombre;
        // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre: screenAtributos.nombre};
        // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre: atributos.nombre};

        // _.set(nuevoEstado.domain.screen.contactos.atributos, this.pathAtributo, this.payload);
        return nuevoEstado;
    }
}
